<template>
  <div v-editable="faq" class="border-b border-[rgba(158,252,78,0.32)]"
       :class="{
          '!border-brand-green': opened,
        }"
  >

    <button
      class="flex mt-4 font-semibold text-left transition-all duration-200 group hover:opacity-80 focus:outline-none text-body w-full"
      @click="opened = !opened"

    >
    <div class="flex justify-between w-full py-[30px] pr-[30px]">
      <span v-html="faq.q"></span>
      <svg class="w-6 h-6 mr-2 transition-all duration-150 transform outline-none group-hover:scale-110"
           :class="{
          'rotate-180': opened,
        }"
        xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M18.1179 5.30486C17.9529 5.30876 17.796 5.3778 17.6817 5.49692L9.99861 13.18L2.3155 5.49692C2.25725 5.43692 2.18754 5.38923 2.11052 5.35666C2.0335 5.32409 1.95072 5.30731 1.8671 5.3073C1.74271 5.30733 1.62117 5.34447 1.51801 5.41397C1.41485 5.48347 1.33477 5.58216 1.28802 5.69742C1.24127 5.81269 1.22997 5.93928 1.25557 6.061C1.28116 6.18272 1.3425 6.29404 1.43171 6.38071L9.55671 14.5057C9.67393 14.6229 9.83288 14.6887 9.99861 14.6887C10.1643 14.6887 10.3233 14.6229 10.4405 14.5057L18.5655 6.38071C18.6564 6.29348 18.7188 6.18082 18.7445 6.0575C18.7703 5.93418 18.7582 5.80596 18.7098 5.68965C18.6614 5.57334 18.579 5.47436 18.4734 5.4057C18.3678 5.33704 18.2439 5.30189 18.1179 5.30486Z" fill="white" stroke="white" stroke-width="2"/>
      </svg>
    </div>

    </button>

    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform -translate-y-3 opacity-0"
      enter-to-class="transform opacity-100"
      leave-active-class="transition duration-300 ease-in"
      leave-from-class="transform opacity-100"
      leave-to-class="transform -translate-y-3 opacity-50"
    >
      <p class="mb-9 text-[14px] text-[#6E7D78] max-w-[72%]" v-if="opened" v-html="faq.a">

      </p>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    faq: Object,
  },

  data() {
    return {
      opened: false,
    };
  },
};
</script>

<style>
</style>
